module.exports = __webpack_public_path__ + "static/media/buffet17.83345401.jpg";